/**
 * Large OTP preview / auto-fill is only allowed when the API explicitly allows it
 * (non-production backend + OTP_EXPOSE_DEV_CODE). Production builds never show it.
 */
export function allowDevOtpAssistUI(exposeDevCodeFromServer?: boolean): boolean {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }
  return exposeDevCodeFromServer === true;
}
